import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4b150d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-page" }
const _hoisted_2 = { class: "account-box" }
const _hoisted_3 = { class: "account-logo" }
const _hoisted_4 = { class: "account-group-input" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "account-name-input" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "account-password-input" }
const _hoisted_9 = { class: "account-password-check" }
const _hoisted_10 = ["disabled"]

import { onMounted, ref, computed } from 'vue'
	import { passwordChangeAxios } from '@/service/account.service'
	import AppImage from '@/components/AppImage.vue'
	import router from '@/router'
	import { ROU_NAME } from '@/router/router.name'

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const userInfo = ref({
		userName: '',
		group: '',
		permission: '',
	})

	const state = ref({
		password: '',
		confirmPassword: '',
	})

	const passwordCheck = computed(() => {
		if (state.value.confirmPassword === '') {
			return true
		}
		if (state.value.password === '') {
			return true
		}
		if (state.value.password === state.value.confirmPassword) {
			return false
		} else {
			return true
		}
	})

	const passwordChange = async (password: string, password2: string) => {
		if (password === password2) {
			await passwordChangeAxios(password)
			alert('password change success')
			return router.push({ name: ROU_NAME.DASHBOARD })
		} else {
			return alert('password not match')
		}
	}

	onMounted(() => {
		userInfo.value.userName = String(sessionStorage.getItem('username'))
		userInfo.value.group = String(sessionStorage.getItem('group'))
		userInfo.value.permission = String(sessionStorage.getItem('permission'))
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppImage, {
      class: "background",
      name: "account_background"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppImage, {
          name: "logo2",
          style: {"width":"350px","height":"68px"}
        })
      ]),
      _createElementVNode("form", {
        class: "account-form",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (passwordChange(state.value.password, state.value.confirmPassword)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("input", {
            type: "text",
            disabled: "",
            placeholder: 'Group : ' + userInfo.value.group
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            type: "text",
            disabled: "",
            placeholder: 'ID : ' + userInfo.value.userName
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            placeholder: "Password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.value.password) = $event))
          }, null, 512), [
            [_vModelText, state.value.password]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            placeholder: "Confirm Password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.value.confirmPassword) = $event))
          }, null, 512), [
            [_vModelText, state.value.confirmPassword]
          ])
        ]),
        _createElementVNode("button", {
          class: "account_btn",
          disabled: _unref(passwordCheck)
        }, _toDisplayString(_ctx.$t('password_edit')), 9, _hoisted_10)
      ], 32)
    ])
  ]))
}
}

})